<template>
    <div>

        <form-wizard  errorColor="rgba(var(--vs-danger), 1)" :title="null"
            :subtitle="null" finishButtonText="Submit" ref="tabs">
            <tab-content title="Movie Details" class="mb-5" icon="feather icon-film" :before-change="validateStep1">
                <addMovie ref="validateDetails" @success="validated" :mData="movie" />
            </tab-content>

            <tab-content title="Options" class="mb-5" icon="feather icon-image" :before-change="fetchMovie">
                <Poster :movie="movie" @success="validated" />
                <h2>Poster</h2>
                
                <hr><br>
                <h2>Cover</h2>
                <Cover :movie="movie" @success="validated" /> <br>
                <hr><br>
                <h2>Banner</h2>
                <Banner :movie="movie" @success="validated" /><br>
                <hr><br>
                <h2>Logo</h2>
                <Logo :movie="movie" @success="validated" /><br>
                <Videos :movie="movie" @success="validated" />

            </tab-content>

            <tab-content title="Filters" class="mb-5" icon="feather icon-video" :before-change="fetchMovie">
                <Options :movie="movie" @success="validated" />
            </tab-content>
            <tab-content title="Seasons" class="mb-5" icon="feather icon-list" :before-change="validateStep3">
                <Seasons :movie="movie.response"/>
            </tab-content>
            <tab-content title="Config" class="mb-5" icon="feather icon-settings" :before-change="validateStep3">

            </tab-content>
        </form-wizard>
    </div>
</template>

<script>
import {
    FormWizard,
    TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import addMovie from './add.vue'
import Poster from './poster.vue'
import Videos from './Videos.vue'
import Options from './options.vue'
import Subtitles from './Subtitles.vue'
// For custom error message
import {
    Validator
} from 'vee-validate';


export default {
    data() {
        return {
            movie: []
        }
    },
    created() {
        if (this.$route.params.id) {
            this.axios.get(`${this.$apiUrl}/v2/seasons/episodes/${this.$route.params.id}`).then(res => {
                this.movie = res.data;
                console.log(this.movie)
            })
        }
    },
    methods: {
        validated(movie) {
            this.movie = movie;

        },
        fetchMovie() {
            if (this.movie.length != 0 && this.movie.response && !this.$route.params.id) {
                this.axios.get(`${this.$apiUrl}/v2/seasons/episodes/${this.movie.response.id}`).then(res => {
                    this.movie = res.data;
                })
            } else {
                this.axios.get(`${this.$apiUrl}/v2/seasons/episodes/${this.$route.params.id}`).then(res => {
                    this.movie = res.data;
                })
            }
            return true;
        },
        validateStep1() {
            return new Promise((resolve, reject) => {
                this.$refs.validateDetails.validate().then(result => {
                    if (result) {
                        if (this.movie.status) {
                            resolve(true)
                           this.$router.push({ name: 'editMovie', params: { id: this.movie.response.id } })
                            this.$refs.tabs.nextTab();
                        }
                    } else {
                        reject('not Validated')
                    }
                })

            })


        },
        validateStep2() {
            return new Promise((resolve, reject) => {

            })
        },
        validateStep3() {
            return new Promise((resolve, reject) => {

            })
        }
    },
    components: {
        FormWizard,
        TabContent,
        addMovie,
        Poster,
        Videos,
        Options,
        Subtitles
    }
}
</script>